import { ReactNode } from 'react'
import { ChangeDirection } from '../types/mutual-fund-detail.types'
import { ChangeDirectionIndicator } from './ui-components/ChangeDirectionIndicator'

type AccordionHeaderContentWithTagPropTypes = {
  title: string
  titleClassName?: string
  titleComponent?: ReactNode
  value?: string
  valueClassName?: string
  changeText?: string
  changeDirection?: `${ChangeDirection}`
  tagText?: string
  isTagHighlighted?: boolean
}

export default function AccordionHeaderContentWithTag({
  title,
  titleClassName,
  titleComponent,
  value,
  valueClassName,
  changeText,
  changeDirection,
  tagText,
  isTagHighlighted
}: AccordionHeaderContentWithTagPropTypes) {
  return (
    <div className='flex flex-col w-full'>
      <div className={`text-[#6A6E6E] text-13 font-[400] leading-[150%] ${titleClassName ?? ''}`}>
        {titleComponent ?? title}
      </div>
      {(value || changeDirection || changeText) && (
        <div className={`flex pt-[2px] ${isTagHighlighted ? 'pb-2' : 'pb-1'}`}>
          {value && (
            <div className={`text-[#00000] font-[500] text-[16px] leading-[130%] ${valueClassName ?? ''}`}>{value}</div>
          )}
          <div className='pl-2'>
            <ChangeDirectionIndicator changeDirection={changeDirection} changeText={changeText} />
          </div>
        </div>
      )}
      {tagText && (
        <div
          className={`text-13 font-[400] rounded-[7px] pb-[3px]
            ${isTagHighlighted ? 'rounded-[7px] px-[6px] bg-[linear-gradient(90deg,rgba(152,152,152,0.10)_30.01%,rgba(152,152,152,0.00)_99.97%)]' : 'text-[#6A6E6E]'}`}
        >
          {tagText}
        </div>
      )}
    </div>
  )
}
